/** @format */
import { css } from 'styled-components';

import { CategoryListProps } from './index';

/**
 * Base styles for the nav list component
 *
 * @param {CategoryListProps} props The nav list properties object
 * */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
const baseStyles = (props: CategoryListProps) => css`
    align-self: start;
    width: 100%;
    z-index: 20;
    padding-top: 1rem;
    .subcategory {
        position: absolute;
        top: 4.8rem;
        left: 0;
        z-index: 50;
        background: var(--colors-surface-primary);
        width: 100%;
        height: calc(100% - 1rem);
        padding-top: 1rem;
        overflow: hidden;
        button {
            margin-bottom: var(--layout-spacing-24);
        }
    }
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

/**
 * The mobile nav list component styles
 *
 * @param {CategoryListProps} props The nav list properties object
 * */
export const styles = (props: CategoryListProps) => css`
    ${baseStyles(props)}
`;
